import React from 'react';
import { Role } from '../../../types/permissions';
import RoleList from './RoleList';
import RoleForm from './RoleForm';

interface RoleManagementModalProps {
  isOpen: boolean;
  onClose: () => void;
  roles: Role[];
  formData: {
    name: string;
    description: string;
  };
  errors: { [key: string]: string };
  isSubmitting: boolean;
  onFieldChange: (field: 'name' | 'description', value: string) => void;
  onCreateRole: () => void;
  onDeleteRole: (roleId: number) => void;
}

const RoleManagementModal: React.FC<RoleManagementModalProps> = ({
  isOpen,
  onClose,
  roles,
  formData,
  errors,
  isSubmitting,
  onFieldChange,
  onCreateRole,
  onDeleteRole
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-6xl relative">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold">Gestionar Roles</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="grid grid-cols-2 gap-6">
          <RoleList
            roles={roles}
            onDeleteRole={onDeleteRole}
          />
          
          <RoleForm
            formData={formData}
            errors={errors}
            isSubmitting={isSubmitting}
            onFieldChange={onFieldChange}
            onSubmit={onCreateRole}
          />
        </div>
      </div>
    </div>
  );
};

export default RoleManagementModal;
